<template>
  <div>
    <!--<transition name="fade">
      <SiteLoader @setLoaderFinished="setLoaderFinished" v-if="!this.loaderFinished"/>
    </transition>-->
    <transition-group name="fade">
      <SiteLoader @setLoaderFinished="setLoaderFinished" v-if="!this.loaderFinished" key="1"/>
      <div class="sections" key="2">
        <TopNav />
        <Landing />
        <!-- <Divider />
        <Form /> -->
        <Footer />
        <div id="topRightDec" class="decoration">
        </div>
        <div id="topLeftDec" class="decoration">
        </div>
        <div id="middleRightDec" class="decoration">
        </div>
        <div id="middleLeftDec" class="decoration">
        </div>
        <div id="middleRightDec2" class="decoration">
        </div>
        <div id="bottomLeftDec" class="decoration">
        </div>
        <div id="bottomRightDec" class="decoration">
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import SiteLoader from "@/components/global/SiteLoader";
import { mapActions, mapState } from "vuex";
import TopNav from "@/components/TopNav/TopNav";
import Landing from "@/components/sections/Landing/Landing";
// import Divider from "@/components/sections/Divider/Divider";
// import Form from "@/components/sections/Form/Form";
import Footer from "@/components/sections/Footer/Footer";
export default {
  name: "Layout",
  components: {
    SiteLoader,
    TopNav,
    Landing,
    // Divider,
    // Form,
    Footer
  },
  computed: {
    ...mapState(["global"])
  },
  data() {
    return {
      firstMount: false,
      loaderFinished: false
    };
  },
  mounted() {
    // Create gtag Script
    var gtagScript = document.createElement("script");
    gtagScript.type = "text/javascript";
    gtagScript.setAttribute("src", "https://www.googletagmanager.com/gtag/js?id=DC-2946440");
    document.head.appendChild(gtagScript);


    //Make sure gtag script above is loaded
    gtagScript.onload = function() {

      // Add gtag config
        window.dataLayer = window.dataLayer || [];
        function gtag(){window.dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'DC-2946440');


      // Add gtag conversion pixel
      gtag('event', 'conversion', {
        'allow_custom_scripts': true,
        'send_to': 'DC-2946440/chcla625/chcgi0+unique'
      });
    };

    let floodlightTag = document.createElement('script')
    floodlightTag.setAttribute('src', 'https://ad.doubleclick.net/ddm/activity/src=2946440;type=chcla625;cat=chcgi0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=1;num=1?')
    document.body.appendChild(floodlightTag)
    this.firstMount = true;
    window.addEventListener(
      "resize",
      () => {
        // window.console.log("inner width", window.innerWidth);
        this.setWindowWidth(window.innerWidth);
      },
      false
    );
    window.addEventListener('scroll', function (e) {
      var scrolled = window.pageYOffset;
      const background = document.getElementById('topLeftDec');
      const background2 = document.getElementById('topRightDec');
      const background3 = document.getElementById('middleRightDec');
      const background4 = document.getElementById('middleLeftDec');
      const background5 = document.getElementById('middleRightDec2');
      // const background6 = document.getElementById('bottomLeftDec');
      // const background7 = document.getElementById('bottomRightDec');
      if(window.innerWidth >= 992) {
        background.style.top = (550 - scrolled * 1.25) + 'px';
        background2.style.top = (90 - scrolled * 1.25) + 'px';
        background3.style.top = (1400 - scrolled * 1.25) + 'px';
        background4.style.top = (1800 - scrolled * 1.25) + 'px';
        background5.style.top = (2200 - scrolled * 1.25) + 'px';
      }
      // if(window.innerWidth <= 992) {
      //   background.style.top = (660 - scrolled * 0.5) + 'px';
      //   background2.style.top = (80 - scrolled * 0.5) + 'px';
      //   background3.style.top = (1400 - scrolled * 0.5) + 'px';
      //   background4.style.top = (1800 - scrolled * 0.5) + 'px';
      //   background5.style.top = (2200 - scrolled * 0.5) + 'px';
      // }
      // background6.style.top = (3350 - scrolled * 1.25) + 'px';
      // background7.style.top = (3150 - scrolled * 1.25) + 'px';
    });
  },
  methods: {
    isMobile(width) {
      return width.windowWidth < 992;
    },
    setLoaderFinished() {
      setTimeout(()=>{
        this.loaderFinished = true;
      }, 1000)
    },
    ...mapActions(["setWindowWidth"])
  }
};
</script>

<style lang="scss" scoped>
/* Fade Transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 2s ease-in-out;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.decoration {
  z-index: 1000;
}

.sections {
  position: relative;
}

#topLeftDec {
  position: fixed;
  left: 0;
  top: 550px;
  background-image: url("~@/assets/images/top-left-decoration.svg");
  background-repeat: no-repeat;
  background-position: top left;
  background-size: contain;
  width: 15%;
  height: 437px;
  @media (max-width: $lg) {
    display: none;
  }
}

#topRightDec {
  position: fixed;
  right: 0;
  top: 90px;
  background-image: url("~@/assets/images/top-right-decoration.svg");
  background-repeat: no-repeat;
  background-position: top right;
  background-size: contain;
  width: 15%;
  height: 404px;
  @media (max-width: $lg) {
    position: absolute;
    top: 80px;
    width: 20%;
  }
}

#middleRightDec {
  position: fixed;
  right: 0;
  top: 1400px;
  background-image: url("~@/assets/images/right-middle-decoration.svg");
  background-repeat: no-repeat;
  background-position: top right;
  background-size: contain;
  width: 7%;
  height: 404px;
  @media (max-width: $lg) {
    display: none;
  }
}

#middleLeftDec {
  position: fixed;
  left: 0;
  top: 1800px;
  background-image: url("~@/assets/images/left-middle-decoration.svg");
  background-repeat: no-repeat;
  background-position: top left;
  background-size: contain;
  width: 8%;
  height: 240px;
  @media (max-width: $lg) {
    display: none;
  }
}

#middleRightDec2 {
  position: fixed;
  right: 0;
  top: 2200px;
  background-image: url("~@/assets/images/right-middle-decoration-2.svg");
  background-repeat: no-repeat;
  background-position: top right;
  background-size: contain;
  width: 10%;
  height: 269px;
  @media (max-width: $lg) {
    display: none;
  }
}

#bottomLeftDec {
  position: absolute;
  left: 0;
  bottom: 0;
  background-image: url("~@/assets/images/left-middle-decoration.svg");
  background-repeat: no-repeat;
  background-position: top left;
  background-size: contain;
  width: 8%;
  height: 240px;
  @media (max-width: $lg) {
    width: 25%;
    height: 677px;
  }
}

#bottomRightDec {
  position: absolute;
  right: 0;
  bottom: 0;
  background-image: url("~@/assets/images/bottom-right-decoration.svg");
  background-repeat: no-repeat;
  background-position: top right;
  background-size: contain;
  width: 15%;
  height: 430px;
  @media (max-width: $lg) {
    width: 32%;
    height: 90px;
  }
}
</style>

<style lang="scss">
  body {
    padding-right: 0 !important;
  }
  .swal2-popup {
    background-image: linear-gradient(180deg, #FFFFFF 0%, #E3E3E3 100%) !important;
    box-shadow: 0 0 12px 6px rgba(0,29,47,0.30) !important;
  }
  .swal2-icon {
    border: 0.35em solid transparent !important;
  }
  .swal2-icon.swal2-error {
    border-color: $orange !important;
    color: $orange !important;
  }
  .swal2-icon.swal2-error [class^=swal2-x-mark-line] {
    background-color: $orange !important;
    border-radius: 2px !important;
  }
  .swal2-title {
    font-family: 'mr-eaves-modern' !important;
    font-weight: 400 !important;
    font-style: normal !important;
    font-size: 30px !important;
    color: #454545 !important;
    text-align: center !important;
  }
  .swal2-content {
    font-family: 'mr-eaves-modern' !important;
    font-weight: 400 !important;
    font-style: normal !important;
    font-size: 18px !important;
    color: #676767 !important;
    letter-spacing: 0 !important;
    text-align: center !important;
    line-height: 22px !important;
  }
  .swal2-styled.swal2-confirm {
    border-radius: 4px !important;
    background-color: $orange !important;
    color: #fff !important;
    font-family: 'mr-eaves-modern' !important;
    font-weight: 400 !important;
    font-style: normal !important;
    font-size: 18px !important;
    color: #FFFFFF !important;
    letter-spacing: 0 !important;
    text-align: center !important;
    border-bottom: 4px solid #fff !important;
    padding: 10px 60px !important;
    transition: all 0.25s ease-in-out !important;
    &:hover {
      background-color: #fff !important;
      border-bottom: 4px solid $orange !important;
      color: $orange !important;
      background-image: none !important;
    }
    &:focus {
      outline: none !important;
      box-shadow: none !important;
    }
  }
</style>